import TableCell from '@tiptap/extension-table-cell';

export default TableCell.extend({
    addAttributes() {
        return {
            ...this.parent?.(),
            style: {
                parseHTML: (element) => element.style?.cssText,
            },
            class: {
                default: null,
            },
            id: {
                default: null,
            },
        };
    },
});
